import React from 'react'
import { useLanguage } from '../i18n/LanguageContext'
import { trackBookingClick, type CtaLocation } from '../lib/tracking'

interface OfferBannerProps {
  ctaLocation: CtaLocation
  variant?: 'top' | 'pricing'
}

export default function OfferBanner({ ctaLocation, variant = 'top' }: OfferBannerProps) {
  const { t } = useLanguage()
  const offer = t.offer

  const isTop = variant === 'top'

  return (
    <section
      className={`animate-on-scroll px-6 md:px-12 ${isTop ? 'pt-10 pb-2' : 'py-16'}`}
      style={{ backgroundColor: isTop ? 'var(--medispa-cloud)' : 'var(--medispa-aloe)' }}
    >
      <div
        className="premium-card max-w-4xl mx-auto px-6 md:px-10 py-8 md:py-10 text-center"
        style={{ borderColor: 'rgba(118, 128, 100, 0.28)' }}
      >
        <div className="eyebrow eyebrow-center justify-center mb-4">
          <span>{offer.title}</span>
        </div>

        <p
          className="text-base md:text-lg font-semibold leading-relaxed max-w-2xl mx-auto mb-2"
          style={{ color: 'var(--medispa-moss)' }}
        >
          {offer.body1}
        </p>

        <p
          className="text-sm md:text-base leading-relaxed max-w-2xl mx-auto mb-7"
          style={{ color: 'var(--medispa-text-grey)' }}
        >
          {offer.body2}
        </p>

        <div className="button-wrapper inline-block">
          <a
            href="https://medispahr.wixforms.com/f/7479898417246766083"
            target="_blank"
            rel="noopener noreferrer"
            data-cta="book_now"
            data-cta-location={`offer_${ctaLocation}`}
            onClick={() => trackBookingClick(ctaLocation)}
            className="cta-premium guten-button inline-block px-9 py-3.5 text-white text-base font-semibold rounded-full"
          >
            <span>{t.common.bookConsultation}</span>
          </a>
        </div>
      </div>
    </section>
  )
}
